export const env = {
    // apiHost: "http://localhost:3030/",
    // frontUrl: "http://localhost:3000/",
    exchangeApi: "https://skgcryparb.com:3030/",
    apiHost: "https://skgcryparb.com:3030/",
    frontUrl: "https://skgcryparb.com/",
  };
